import { STATUS_TYPE } from '../../../enum';

export interface CreateChangeUserProfileStatus {
  userId: string;
  isApproved: boolean;
  rejectionReason?: string;
  tradeLicenseExpirationDate?: string; // ISO date string
  brokerLicenseExpirationDate?: string; // ISO date string
}

export interface ChangeUserProfileStatus {
  id: string;
  userId: string;
  isApproved: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: ChangeUserProfileStatus[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
